import { z } from 'zod';

import { HelpVisibilityInput } from '@nucleus-commerce/api-client/admin';

import { handleSchema, positionSchema } from './help-article-form-schema';

/** `/help/a/<article>` and `/help/search` are storefront routes, so no category may take them. */
export const RESERVED_CATEGORY_HANDLES: ReadonlySet<string> = new Set(['a', 'search']);

export const helpCategoryFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { error: 'helpCenter:validation.nameRequired' })
    .max(120, { error: 'helpCenter:validation.nameLength' }),
  handle: handleSchema.refine((handle) => !RESERVED_CATEGORY_HANDLES.has(handle), {
    error: 'helpCenter:validation.handleReserved',
  }),
  description: z.string().trim().max(2000, { error: 'helpCenter:validation.descriptionLength' }),
  position: positionSchema,
  visibility: z.enum(HelpVisibilityInput),
});

export type HelpCategoryForm = z.infer<typeof helpCategoryFormSchema>;
